<template>
  <section
    v-if="showBannerSection"
    class="home-banner"
    :class="{ 'home-banner--h5': isMobileBanner }"
    aria-label="首页推荐轮播"
  >
    <div v-if="isLoading" class="home-banner__state">
      <div class="home-banner__skeleton" />
    </div>

    <div
      v-else-if="fetchFailed"
      class="home-banner__state home-banner__state--error"
    >
      <p class="home-banner__error-text">轮播加载失败</p>
      <button
        type="button"
        class="home-banner__retry-button"
        @click="refetchBanner"
      >
        重试
      </button>
    </div>

    <div v-else class="home-banner__stage" :class="{ 'home-banner__stage--h5': isMobileBanner }">
      <button
        v-if="slideCount > 1 && !isMobileBanner"
        type="button"
        class="home-banner__nav home-banner__nav--prev"
        aria-label="上一屏"
        @click="goPrevByUser"
      >
        <AppIcon name="arrowLeft" size="lg" class="icon icon-lg" aria-label="" />
      </button>

      <div ref="viewportRef" class="home-banner__viewport" :class="{ 'home-banner__viewport--h5': isMobileBanner }">
        <HomeBannerH5Track
          v-if="isMobileBanner"
          :slot-maps="allSlideSlotMaps"
          :active-index="activeIndex"
          :slide-direction="slideDirection"
          :slide-count="slideCount"
          :show-dots="slideCount > 1"
          @comic-click="handleComicClick"
          @go-to-slide="goToSlideByUser"
        />
        <HomeBannerWebTrack
          v-else
          :slot-maps="allSlideSlotMaps"
          :active-index="activeIndex"
          :slide-direction="slideDirection"
          :slide-count="slideCount"
          :show-dots="slideCount > 1"
          @comic-click="handleComicClick"
          @go-to-slide="goToSlideByUser"
        />

        <template v-if="!isMobileBanner && slideCount > 1">
          <button
            type="button"
            class="home-banner__side-hit home-banner__side-hit--left"
            aria-label="上一屏"
            @click="goPrevByUser"
          />
          <button
            type="button"
            class="home-banner__side-hit home-banner__side-hit--right"
            aria-label="下一屏"
            @click="goNextByUser"
          />
          <div class="home-banner__vignette" aria-hidden="true" />
        </template>
      </div>

      <button
        v-if="slideCount > 1 && !isMobileBanner"
        type="button"
        class="home-banner__nav home-banner__nav--next"
        aria-label="下一屏"
        @click="goNextByUser"
      >
        <AppIcon name="chevronRight" size="lg" class="icon icon-lg" aria-label="" />
      </button>
    </div>
  </section>
</template>

<script setup>
import { computed } from 'vue'
import AppIcon from '@/shared/components/AppIcon.vue'
import HomeBannerH5Track from '@/features/home/components/HomeBannerH5Track.vue'
import HomeBannerWebTrack from '@/features/home/components/HomeBannerWebTrack.vue'
import { useHomeBanner } from '@/features/home/composables/useHomeBanner'
import { useHomeBannerTouch } from '@/features/home/composables/useHomeBannerTouch'

const {
  viewportRef,
  isLoading,
  fetchFailed,
  hasItems,
  isMobileBanner,
  slideCount,
  activeIndex,
  slideDirection,
  allSlideSlotMaps,
  goPrevByUser,
  goNextByUser,
  goToSlideByUser,
  onComicClick,
  refetchBanner,
} = useHomeBanner()

/** 无轮播数据时不占位；加载中、有数据、加载失败时展示 Banner 区域 */
const showBannerSection = computed(
  () => isLoading.value || hasItems.value || fetchFailed.value
)

const { shouldSuppressComicClick } = useHomeBannerTouch(viewportRef, {
  onSwipePrev: goPrevByUser,
  onSwipeNext: goNextByUser,
})

/**
 * @param {import('@/features/home/api/homeApi').HomeBannerComic} comic
 */
function handleComicClick(comic) {
  if (shouldSuppressComicClick()) return
  onComicClick(comic)
}
</script>

<style scoped src="@/features/home/styles/HomeBanner.css"></style>
